import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { BeneficiaryContactDto } from '../models/beneficiary-contact.dto';
import { ContactDto } from '../models/contact.dto';
import { EmailMessageDto } from '../models/email-message.dto';
import { MailingDto } from '../models/mailing.dto';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class MailService {
  constructor(private readonly api: ApiService) {}

  public async getContacts(): Promise<ContactDto[]> {
    return this.api.get<ContactDto[]>(environment.api.mail + '/contacts');
  }

  public async sendMail(message: EmailMessageDto): Promise<void> {
    return this.api.post<void, EmailMessageDto>(environment.api.mail + '/send', message);
  }

  public async sendMailList(message: MailingDto): Promise<BeneficiaryContactDto[]> {
    return this.api.post<BeneficiaryContactDto[], MailingDto>(environment.api.mail + '/send/list', message);
  }
}
